// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AdminLoginForm-loginMainBg-n29lW {
	display: grid;
	grid-template-columns: 50% 50%;
	height: 100vh;
}

.AdminLoginForm-bgPadding-R88G3 {
	padding: 12px 0 12px 12px;
}

.AdminLoginForm-loginBg-_dnor {
	width: 100%;
	height: 100%;
	background-repeat: no-repeat;
	background-size: cover;
	background-position: 50% 50%;
	border-radius: 6px;
}

.AdminLoginForm-leftPadding-vXyc6 {
	padding: 30px 12px 12px;
}

.AdminLoginForm-formInner-Z5PSO {
	width: 100%;
	max-width: 450px;
	margin: 40px auto 0;
	padding: 20px 15px 10px;
}

.AdminLoginForm-loginTitleSection-GfhwT {
	text-align: center;
	margin-bottom: 36px;
}

.AdminLoginForm-loginTitleSection-GfhwT img {
	width: 100%;
	max-width: 120px;
}

.AdminLoginForm-fullWidth-L_af3 {
	width: 100%;
}

.AdminLoginForm-loginButton-pp2F5 {
	text-align: center;
	margin-top: 24px;
}

.AdminLoginForm-loginButton-pp2F5 button {
	width: 100%;
}

/* header start */

.AdminLoginForm-adminLogInHeaderContainer-y16hg {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	-webkit-box-pack: end;
	    -ms-flex-pack: end;
	        justify-content: flex-end;
	border-bottom: 1px solid var(--primary-border);
	padding-bottom: 30px;
}

.AdminLoginForm-adminLogInHeaderNavMenuContainer-LpgQR {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	-webkit-box-pack: end;
	    -ms-flex-pack: end;
	        justify-content: flex-end;
	gap: 24px;
	grid-gap: 24px;
}

.AdminLoginForm-adminLogInHeaderMenuItem-ES4qA,
.AdminLoginForm-adminLogInHeaderMenuItem-ES4qA:hover,
.AdminLoginForm-adminLogInHeaderMenuItem-ES4qA:focus,
.AdminLoginForm-adminLogInHeaderMenuItem-ES4qA:active,
.AdminLoginForm-adminLogInHeaderMenuItem-ES4qA:active:hover,
.AdminLoginForm-adminLogInHeaderMenuItem-ES4qA:active:focus {
	font-size: 16px;
	font-weight: 500;
	line-height: 24px;
	padding: 0 !important;
	display: -webkit-box !important;
	display: -ms-flexbox !important;
	display: flex !important;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 4px;
	grid-gap: 4px;
	color: var(--primary-foreground) !important;
	background-color: transparent !important;
	text-decoration: none;
	outline: unset;
	-webkit-box-shadow: unset;
	        box-shadow: unset;
	border: unset;
	text-align: start;
	cursor: pointer;
}

.AdminLoginForm-adminLogInHeaderMenuItemIconBox-qO0ws {
	display: inline-block;
	position: relative;
	-ms-flex-negative: 0;
	    flex-shrink: 0;
	width: 20px;
	height: 20px;
}

.AdminLoginForm-adminLogInHeaderMenuItemIcon-NkCHh {
	position: absolute;
	inset: 0;
	width: 100%;
	height: 100%;
	-o-object-fit: contain;
	   object-fit: contain;
	-o-object-position: center;
	   object-position: center;
}

.AdminLoginForm-adminLogInHeaderDropdownMenuItem-PKC9O .AdminLoginForm-adminLogInHeaderMenuItemIconBox-qO0ws {
	top: -3px;
}

.AdminLoginForm-adminLogInHeaderDropdownMenuInnerWrapper-jA19T {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	-webkit-box-pack: start;
	    -ms-flex-pack: start;
	        justify-content: flex-start;
	gap: 8px;
	grid-gap: 8px;
}

.AdminLoginForm-adminLogInHeaderDropdownMenuSelect-ng0mB {
	color: var(--primary-link-foreground);
}

.AdminLoginForm-loginTitleText-IUDEP {
	font-size: 18px;
	font-weight: 500;
	line-height: 28px;
	margin-bottom: 6px;
	color: var(--primary-foreground);
}

/* header end */

@media screen and (max-width: 991px) {
	.AdminLoginForm-loginMainBg-n29lW {
		grid-template-columns: 100%;
	}

	.AdminLoginForm-bgPadding-R88G3 {
		display: none;
	}

}

@media screen and (max-width: 767px) {
	.AdminLoginForm-flexEnd-ntk6d {
		-ms-flex-wrap: wrap;
		    flex-wrap: wrap;
		grid-gap: 15px;
		-webkit-box-pack: center;
		    -ms-flex-pack: center;
		        justify-content: center;
	}

	.AdminLoginForm-adminLogInHeaderMenuItemText-kCHKx {
		display: none;
	}
}`, "",{"version":3,"sources":["webpack://./src/components/SiteAdmin/AdminLoginForm/AdminLoginForm.css"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,8BAA8B;CAC9B,aAAa;AACd;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,4BAA4B;CAC5B,sBAAsB;CACtB,4BAA4B;CAC5B,kBAAkB;AACnB;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,WAAW;CACX,gBAAgB;CAChB,mBAAmB;CACnB,uBAAuB;AACxB;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,WAAW;CACX,gBAAgB;AACjB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,WAAW;AACZ;;AAEA,iBAAiB;;AAEjB;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,qBAAyB;KAAzB,kBAAyB;SAAzB,yBAAyB;CACzB,8CAA8C;CAC9C,oBAAoB;AACrB;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,qBAAyB;KAAzB,kBAAyB;SAAzB,yBAAyB;CACzB,SAAS;CACT,cAAc;AACf;;AAEA;;;;;;CAMC,eAAe;CACf,gBAAgB;CAChB,iBAAiB;CACjB,qBAAqB;CACrB,+BAAwB;CAAxB,+BAAwB;CAAxB,wBAAwB;CACxB,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,QAAQ;CACR,aAAa;CACb,2CAA2C;CAC3C,wCAAwC;CACxC,qBAAqB;CACrB,cAAc;CACd,yBAAiB;SAAjB,iBAAiB;CACjB,aAAa;CACb,iBAAiB;CACjB,eAAe;AAChB;;AAEA;CACC,qBAAqB;CACrB,kBAAkB;CAClB,oBAAc;KAAd,cAAc;CACd,WAAW;CACX,YAAY;AACb;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,WAAW;CACX,YAAY;CACZ,sBAAmB;IAAnB,mBAAmB;CACnB,0BAAuB;IAAvB,uBAAuB;AACxB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,uBAA2B;KAA3B,oBAA2B;SAA3B,2BAA2B;CAC3B,QAAQ;CACR,aAAa;AACd;;AAEA;CACC,qCAAqC;AACtC;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,iBAAiB;CACjB,kBAAkB;CAClB,gCAAgC;AACjC;;AAEA,eAAe;;AAEf;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,aAAa;CACd;;AAED;;AAEA;CACC;EACC,mBAAe;MAAf,eAAe;EACf,cAAc;EACd,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;CACxB;;CAEA;EACC,aAAa;CACd;AACD","sourcesContent":[".loginMainBg {\n\tdisplay: grid;\n\tgrid-template-columns: 50% 50%;\n\theight: 100vh;\n}\n\n.bgPadding {\n\tpadding: 12px 0 12px 12px;\n}\n\n.loginBg {\n\twidth: 100%;\n\theight: 100%;\n\tbackground-repeat: no-repeat;\n\tbackground-size: cover;\n\tbackground-position: 50% 50%;\n\tborder-radius: 6px;\n}\n\n.leftPadding {\n\tpadding: 30px 12px 12px;\n}\n\n.formInner {\n\twidth: 100%;\n\tmax-width: 450px;\n\tmargin: 40px auto 0;\n\tpadding: 20px 15px 10px;\n}\n\n.loginTitleSection {\n\ttext-align: center;\n\tmargin-bottom: 36px;\n}\n\n.loginTitleSection img {\n\twidth: 100%;\n\tmax-width: 120px;\n}\n\n.fullWidth {\n\twidth: 100%;\n}\n\n.loginButton {\n\ttext-align: center;\n\tmargin-top: 24px;\n}\n\n.loginButton button {\n\twidth: 100%;\n}\n\n/* header start */\n\n.adminLogInHeaderContainer {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: flex-end;\n\tborder-bottom: 1px solid var(--primary-border);\n\tpadding-bottom: 30px;\n}\n\n.adminLogInHeaderNavMenuContainer {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: flex-end;\n\tgap: 24px;\n\tgrid-gap: 24px;\n}\n\n.adminLogInHeaderMenuItem,\n.adminLogInHeaderMenuItem:hover,\n.adminLogInHeaderMenuItem:focus,\n.adminLogInHeaderMenuItem:active,\n.adminLogInHeaderMenuItem:active:hover,\n.adminLogInHeaderMenuItem:active:focus {\n\tfont-size: 16px;\n\tfont-weight: 500;\n\tline-height: 24px;\n\tpadding: 0 !important;\n\tdisplay: flex !important;\n\talign-items: center;\n\tgap: 4px;\n\tgrid-gap: 4px;\n\tcolor: var(--primary-foreground) !important;\n\tbackground-color: transparent !important;\n\ttext-decoration: none;\n\toutline: unset;\n\tbox-shadow: unset;\n\tborder: unset;\n\ttext-align: start;\n\tcursor: pointer;\n}\n\n.adminLogInHeaderMenuItemIconBox {\n\tdisplay: inline-block;\n\tposition: relative;\n\tflex-shrink: 0;\n\twidth: 20px;\n\theight: 20px;\n}\n\n.adminLogInHeaderMenuItemIcon {\n\tposition: absolute;\n\tinset: 0;\n\twidth: 100%;\n\theight: 100%;\n\tobject-fit: contain;\n\tobject-position: center;\n}\n\n.adminLogInHeaderDropdownMenuItem .adminLogInHeaderMenuItemIconBox {\n\ttop: -3px;\n}\n\n.adminLogInHeaderDropdownMenuInnerWrapper {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: flex-start;\n\tgap: 8px;\n\tgrid-gap: 8px;\n}\n\n.adminLogInHeaderDropdownMenuSelect {\n\tcolor: var(--primary-link-foreground);\n}\n\n.loginTitleText {\n\tfont-size: 18px;\n\tfont-weight: 500;\n\tline-height: 28px;\n\tmargin-bottom: 6px;\n\tcolor: var(--primary-foreground);\n}\n\n/* header end */\n\n@media screen and (max-width: 991px) {\n\t.loginMainBg {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.bgPadding {\n\t\tdisplay: none;\n\t}\n\n}\n\n@media screen and (max-width: 767px) {\n\t.flexEnd {\n\t\tflex-wrap: wrap;\n\t\tgrid-gap: 15px;\n\t\tjustify-content: center;\n\t}\n\n\t.adminLogInHeaderMenuItemText {\n\t\tdisplay: none;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loginMainBg": `AdminLoginForm-loginMainBg-n29lW`,
	"bgPadding": `AdminLoginForm-bgPadding-R88G3`,
	"loginBg": `AdminLoginForm-loginBg-_dnor`,
	"leftPadding": `AdminLoginForm-leftPadding-vXyc6`,
	"formInner": `AdminLoginForm-formInner-Z5PSO`,
	"loginTitleSection": `AdminLoginForm-loginTitleSection-GfhwT`,
	"fullWidth": `AdminLoginForm-fullWidth-L_af3`,
	"loginButton": `AdminLoginForm-loginButton-pp2F5`,
	"adminLogInHeaderContainer": `AdminLoginForm-adminLogInHeaderContainer-y16hg`,
	"adminLogInHeaderNavMenuContainer": `AdminLoginForm-adminLogInHeaderNavMenuContainer-LpgQR`,
	"adminLogInHeaderMenuItem": `AdminLoginForm-adminLogInHeaderMenuItem-ES4qA`,
	"adminLogInHeaderMenuItemIconBox": `AdminLoginForm-adminLogInHeaderMenuItemIconBox-qO0ws`,
	"adminLogInHeaderMenuItemIcon": `AdminLoginForm-adminLogInHeaderMenuItemIcon-NkCHh`,
	"adminLogInHeaderDropdownMenuItem": `AdminLoginForm-adminLogInHeaderDropdownMenuItem-PKC9O`,
	"adminLogInHeaderDropdownMenuInnerWrapper": `AdminLoginForm-adminLogInHeaderDropdownMenuInnerWrapper-jA19T`,
	"adminLogInHeaderDropdownMenuSelect": `AdminLoginForm-adminLogInHeaderDropdownMenuSelect-ng0mB`,
	"loginTitleText": `AdminLoginForm-loginTitleText-IUDEP`,
	"flexEnd": `AdminLoginForm-flexEnd-ntk6d`,
	"adminLogInHeaderMenuItemText": `AdminLoginForm-adminLogInHeaderMenuItemText-kCHKx`
};
module.exports = ___CSS_LOADER_EXPORT___;
